import { FC } from 'react';

import { ResponsiveImageGroup } from '../common/model';
import { PromoCardLargeImage, PromoCardMediumImage, PromoCardSmallImage } from './BlockPromo.styles';

type Props = {
    images: ResponsiveImageGroup;
};

export const PromoCardImage: FC<Props> = ({ images }) => {
    const altText = images.altText || images.imageSm.alt || images.imageMd.alt || images.imageLg.alt || '';

    const commonProps = {
        'data-element': 'Banner',
        'data-element-name': altText,
        role: altText ? 'img' : 'presentation',
        alt: altText,
    };

    return (
        <>
            <PromoCardSmallImage {...commonProps} src={images.imageSm.src} />
            <PromoCardMediumImage {...commonProps} src={images.imageMd.src} />
            <PromoCardLargeImage {...commonProps} src={images.imageLg.src} />
        </>
    );
};
